import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import {
  partialCtaDefaultLinearGradientBackground,
  partialCtaHoverLinearGradientBackground,
} from "@/components/AIComponents/AiComponents.style";

const { ui } = constants.colors;

export const bannerCss = { root: { borderRadius: "8px" } };
export const generateButtonWrapperCss: CSSObject = {
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "49px",
  padding: "1rem",
  borderTop: `1px solid ${ui.neutral[100]}`,
};

export const generateButtonCss: CSSObject = {
  ...partialCtaDefaultLinearGradientBackground,

  "&:hover, &:focus-visible": {
    ...partialCtaHoverLinearGradientBackground,
  },
};

export const lessonPlannerFormCss: CSSObject = {
  padding: "1em",
};
